import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentFailed = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 px-6 flex items-center justify-center" data-testid="payment-failed-page">
      <div className="max-w-2xl mx-auto text-center">
        <div className="glass-card p-12">
          <XCircle className="w-20 h-20 text-destructive mx-auto mb-6" data-testid="failed-icon" />
          
          <h1 className="text-4xl font-bold mb-4" data-testid="failed-title">
            Payment Failed
          </h1>
          
          <p className="text-muted-foreground text-lg mb-8">
            We couldn't process your payment. Please try again or contact support if the issue persists.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/cart"
              className="btn-primary"
              data-testid="retry-payment-button"
            >
              Retry Payment
            </Link>
            <Link
              to="/"
              className="px-8 py-4 bg-white/5 text-foreground border border-white/10 hover:bg-white/10 transition-all duration-300 rounded-full font-semibold"
              data-testid="back-home-button"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
